import useTradeHistory from '../../../hooks/web3/trade/useTradeHistory';
import Spinner from '../../../components/Spinner';
import useTradePools from '../../../hooks/web3/trade/useTradePools';
import HistoryRow from './HistoryRow';
import usePagination from '../../../hooks/usePagination';
import Pagination from '../../../components/Pagination';

const headers = ['Date', 'Type', 'Size', 'Entry Price', 'Close Price', 'Realized PNL'];

const ROW_COUNT = 10;

const GlobalTradeHistory = () => {
    const { isLoading, error } = useTradePools();
    const {
        tradeHistory,
        isLoading: historyLoading,
        error: historyError,
    } = useTradeHistory();

    console.log(error);

    const pagination = usePagination(ROW_COUNT, tradeHistory?.length || 0);

    return (
        <div className='global-trade-history'>
            {isLoading || historyLoading ? (
                <div className='loading-container'>
                    <Spinner />
                    <span>Loading history</span>
                </div>
            ) : tradeHistory && tradeHistory.length ? (
                <>
                    <div className='row header'>
                        {headers.map((header, index) => (
                            <div key={index}>{header}</div>
                        ))}
                    </div>
                    {pagination.paginateData(tradeHistory).map((history, index) => (
                        <HistoryRow history={history} key={index} />
                    ))}
                </>
            ) : error || historyError ? (
                <div className='row error'>We had trouble loading the history...</div>
            ) : (
                <div className='row error'>No positions have been opened yet</div>
            )}
            {tradeHistory && tradeHistory.length > 5 ? (
                <Pagination pagination={pagination} />
            ) : null}
        </div>
    );
};

export default GlobalTradeHistory;
